export function kvNummerIsValid(kvNummer: string): boolean {
  const regEx = new RegExp('^[A-Za-z]\\d{9}$|^\\d{9}$');
  return regEx.test(kvNummer);
}



// WEBPACK FOOTER //
// ./src/app/befreiung/shared/kvNummerIsValid.ts